import { render, staticRenderFns } from "./AddHowItWorks.vue?vue&type=template&id=b70dbbbe&scoped=true&"
import script from "./AddHowItWorks.vue?vue&type=script&lang=js&"
export * from "./AddHowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70dbbbe",
  null
  
)

export default component.exports